import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'antd';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { CalendarDays } from 'lucide-react';

function PreOrder({
  platform,
  preOrderStatus,
}: {
  platform?: General.PlatformUpperCaseTunnel;
  preOrderStatus: Conversation.Product['preOrderStatus'];
}) {
  const { t } = useTranslate();

  return preOrderStatus === 'ALL_PRE_ORDER' ? (
    <Tooltip
      title={t(isTiKTokUpperCase(platform) ? '全部SKU预购' : 'domain.product.type.preOrder')}
    >
      <Icon
        style={{
          color: 'var(--fett-scenario-success-text)',
          background: 'var(--fett-scenario-success-bg)',
        }}
      />
    </Tooltip>
  ) : preOrderStatus === 'PARTIAL_PRE_ORDER' ? (
    <Tooltip title={t('部分SKU预购')}>
      <Icon
        style={{
          color: 'var(--fett-scenario-accent-text)',
          background: 'var(--fett-scenario-accent-strong-bg)',
        }}
      />
    </Tooltip>
  ) : (
    <></>
  );
}

const Icon = styled(CalendarDays)`
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-right: 2px;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
`;

export default PreOrder;
